/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrganizationFeaturesFromDiscriminatorValue, serializeOrganizationFeatures, serializeUpdateOrganizationFeaturesRequest, type ErrorResponse, type InternalErrorResponse, type OrganizationFeatures, type UpdateOrganizationFeaturesRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/features
 */
export interface FeaturesRequestBuilder extends BaseRequestBuilder<FeaturesRequestBuilder> {
    /**
     * Replaces the organization's feature switches. Every switch is off until an admin turns it on, so a tenant that never calls this sees no new behaviour. Turning product variants off again hides families and the option registry without deleting them; the current switches are returned by GetOrganization under features.
     * @param body Replaces the organization's feature switches.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrganizationFeatures>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateOrganizationFeaturesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrganizationFeatures | undefined>;
    /**
     * Replaces the organization's feature switches. Every switch is off until an admin turns it on, so a tenant that never calls this sees no new behaviour. Turning product variants off again hides families and the option registry without deleting them; the current switches are returned by GetOrganization under features.
     * @param body Replaces the organization's feature switches.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateOrganizationFeaturesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FeaturesRequestBuilderUriTemplate = "{+baseurl}/api/organizations/features";
/**
 * Metadata for all the requests in the request builder.
 */
export const FeaturesRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: FeaturesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrganizationFeaturesFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateOrganizationFeaturesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
